import React, { useContext } from 'react'

import Hand from '../../../assets/logos/logoHand.svg'
import MyContext from '../../../contexts/_ModalData/modal'
import './styles.css'

export default (props)=>{

    const { setDataPF, setDataPJ } = useContext(MyContext);

    const name = (props.data.name).split(/(\s).+\s/).join("");

    const handleModal = () =>{

        const data = props.data;

        if(props.data.establishment){
            setDataPJ(data);
            props.setShowPJ(true);
        }
        else{
            setDataPF(data);
            props.setShowPF(true);
        }

    }
    
    return(
        <div className='card-profiles'>
            <div className='card-profiles-image'>
                <img src={Hand} alt="hand"/>
            </div>

            <div className='card-profiles-info'>
                <p className='card-profiles-text-UP'>
                    {name.length > 15 ? 
                            (name.substr(0,15)+'...')
                        : 
                            name
                    }
                </p>
                <p className='card-profiles-text'>{
                    props.data.email ? 
                        props.data.email.length > 40 ?
                            (props.data.email.substr(0,40)+'...'):props.data.email
                        : ''
                }</p>
                {props.data.establishment ?<p className='card-profiles-text-UP lsss'>{props.data.establishment}</p>:null}
                <p className='card-profiles-text-button' id='show-data-button'onClick={handleModal}>Ver dados</p>
            </div>
        </div>
    )
}